<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="800">
      <v-card>
        <v-card-title class="text-h5"> List Data BL </v-card-title>

        <v-container>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
            v-if="loading"
          >
            <v-col class="text-subtitle-1 text-center" cols="12">
              Loading Data
            </v-col>
            <v-col cols="6">
              <v-progress-linear
                color="deep-purple accent-4"
                indeterminate
                rounded
                height="6"
              ></v-progress-linear>
            </v-col>
          </v-row>
          <v-simple-table v-else>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left" width="12%">KC</th>
                  <th class="text-left" width="15%">Seal</th>
                  <th class="text-left" width="20%">NoCont</th>
                  <th class="text-left" width="15%">Cargo</th>
                  <th class="text-left" width="20%">BL</th>
                  <!-- <th class="text-left">NoBL</th> -->
                  <th class="text-left">NoSPK</th>
                  <th class="text-left">TglSPK</th>
                </tr>
              </thead>
              <tbody>
                <Container
                  v-for="container in containers"
                  :key="container.id"
                  :data="container"
                />
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            tabindex="-1"
            @click="$emit('close-modal')"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "ListBL",
  props: ["openModal", "kv"],
  components: {
    Container: () => import("@/components/DataBL/Container.vue")
  },
  data() {
    return {
      loading: false,
      containers: []
    };
  },
  watch: {
    openModal(val) {
      if (val) {
        this.getBL();
      }
    }
  },
  methods: {
    async getBL() {
      this.loading = true;

      await axios
        .get(`data-bl/${this.kv}`)
        .then(res => {
          // console.log(res.data);

          this.loading = false;
          this.containers = res.data.container;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>
